import {
  AppstoreOutlined,
  HomeOutlined,
  LoginOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

import { CartMenu } from '@eshop/pages/cart/CartMenu.tsx';
import LoginButton from '@login/pages/LoginButton.tsx';
import { useAppSelector } from '@store/store.tsx';

import { UserMenu } from '@pages/cmp/nav/UserMenu.tsx';
import { useCheckoutLayout } from '@eshop/hooks/useCheckoutLayout.tsx';

export const OPEN_CATALOGUE_FILTERS_EVENT = 'eshop:open-catalogue-filters';

const emitOpenFilters = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(OPEN_CATALOGUE_FILTERS_EVENT));
};

export const SoftCommerceBottomNav = () => {
  const location = useLocation();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const { checkoutMode } = useCheckoutLayout();

  if (checkoutMode) {
    return null;
  }

  const pathname = location.pathname;
  const isCatalogue = pathname.startsWith('/eshop/catalogue') || pathname.startsWith('/eshop/category');
  const isCart = pathname.startsWith('/eshop/cart');
  const isAccount = pathname.startsWith('/eshop/account');

  return (
    <nav className="soft-commerce-bottom-nav" aria-label="Navegación principal móvil">
      <Link
        to="/eshop/catalogue"
        className={`soft-commerce-bottom-nav__item${isCatalogue ? ' is-active' : ''}`}
      >
        <HomeOutlined />
        <span>Inicio</span>
      </Link>
      <button type="button" className="soft-commerce-bottom-nav__item" onClick={emitOpenFilters}>
        <AppstoreOutlined />
        <span>Categorías</span>
      </button>
      <div className={`soft-commerce-bottom-nav__item soft-commerce-bottom-nav__cart${isCart ? ' is-active' : ''}`}>
        <CartMenu shape="default" />
        <span>Carrito</span>
      </div>
      {isAuthenticated ? (
        <UserMenu placement="topRight">
          <div className={`soft-commerce-bottom-nav__item${isAccount ? ' is-active' : ''}`} style={{ cursor: 'pointer' }}>
            <UserOutlined />
            <span>Menú</span>
          </div>
        </UserMenu>
      ) : (
        <div className="soft-commerce-bottom-nav__item soft-commerce-bottom-nav__login">
          <LoginButton extraClass="soft-commerce-bottom-nav__login-button" intoIcon={<LoginOutlined />} />
        </div>
      )}
    </nav>
  );
};

export default SoftCommerceBottomNav;
